import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { RelatedSearchService } from './related.search.service';
import * as _ from 'lodash';

@Component({
  selector: 'related-search',
  template: require('./related-search.component.html')
})
export class RelatedSearchComponent implements OnInit, OnChanges {
  @Input() project: any;
  @Input() search: string;
  @Input() section: string;
  @Input() sections: any;
  @Input() sectionTitle: string;
  @Input() includeSite: boolean;
  @Input() totalCount: any;
  @Input() maxPage: number;

  searchResult: any = false;
  doSearch: any;
  visibleSection: string = '';
  loading: boolean = false;

  constructor(private relatedSearchService: RelatedSearchService) {}

  ngOnInit() {
    this.doSearch = _.debounce(this.searchFunction, 500);
    this.searchFunction();
  }

  ngOnChanges() {
    if (this.doSearch) {
      this.doSearch();
    }
  }

  showResults() {
    if (this.search.trim() === '') {
      return false;
    }
    return this.searchResult !== false;
  }

  showSection(tgt: string) {
    this.visibleSection = this.visibleSection === tgt ? '' : tgt;
  }

  setResultDisplay(newResult: any) {
    if (this.visibleSection !== '') {
      if (newResult[this.visibleSection]?.length > 0) {
        return;
      }
    }

    const firstSectionWithResults = ['sameSection', 'sameProject', 'otherProject', 'otherSources'].find(
      section => newResult[section]?.length > 0
    );

    if (firstSectionWithResults) {
      this.showSection(firstSectionWithResults);
    } else {
      this.showSection('');
    }
  }

  searchFunction() {
    if (this.search.trim() === '') {
      if (this.searchResult) {
        this.searchResult = false;
      }
    } else {
      this.loading = true;
      this.relatedSearchService
        .doSearch(this.search, this.sections, 20)
        .then((results: any) => {
          this.searchResult = this.relatedSearchService.sortResults(results, this.section, this.sectionTitle, this.project);
        })
        .catch((err) => {})
        .then(() => {
          this.loading = false;
          _.set(this.totalCount, 'total', _.get(this.searchResult, 'total', 0));
          this.setResultDisplay(this.searchResult);
        });
    }
  }
}
